import { defineStore } from 'pinia'

import type { TeamsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useTeamsStore = defineStore('teams', {
  state: (): TeamsStore => ({
    loading: false,
    saving: false,
    teams: [],
    meta: null,
    users: [],
    filterSearch: null,
    currentPage: 1,
    perPage: 25,
    teamToDelete: null,
    currentTeam: null,
    isModalCreate: false,
  }),
  actions,
  getters,
})
